import * as pdfjsLib from 'pdfjs-dist';

// Ensure PDF.js uses the correct worker. Find the correct version by searching for `pdfjsVersion` in node_modules/pdfjs-dist. Note: v4 did not work for me, using v2 because it works
pdfjsLib.GlobalWorkerOptions.workerSrc =
  '//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js';

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="atom-download-teaser"]';

/**
 * Friendation component
 */
export const atomDownloadTeaser = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    const handlePdf = async () => {
      const downloadLink: HTMLAnchorElement = component.querySelector(
        '[download][data-file-kind="pdf"]'
      );
      if (!downloadLink) return;

      /**
       * Absolute link to PDF file
       * @example "https://example.com/uploads/file.pdf"
       */
      const href = downloadLink.href;
      if (!href || !href.length) return;

      const thumbnailWrapper: HTMLDivElement =
        component.querySelector('.thumbnail');
      if (!thumbnailWrapper) return;

      /** Find any existing image (to prevent duplicates) */
      const existingImage = thumbnailWrapper.querySelector('img');
      if (existingImage) return;

      // Render the first page of the PDF
      try {
        // Load the PDF
        const loadingTask = pdfjsLib.getDocument(href);
        const pdfDocument = await loadingTask.promise;

        // Get the first page
        const page = await pdfDocument.getPage(1);

        // Set scale (adjust based on the size you want for the thumbnail)
        const scale = 0.5;
        const viewport = page.getViewport({ scale });

        // Create a canvas element
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        if (!context) return;

        // Set the canvas size to the viewport size
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Render the page into the canvas
        await page.render({
          canvasContext: context,
          viewport: viewport
        }).promise;

        // Convert the canvas to an image URL
        const imageUrl = canvas.toDataURL();

        // Create an img element and append it to the thumbnail wrapper
        const img = document.createElement('img');
        img.src = imageUrl;
        img.alt = 'PDF Thumbnail';
        thumbnailWrapper.innerHTML = ''; // Clear previous content
        thumbnailWrapper.appendChild(img);
      } catch (error) {
        console.error('Error rendering PDF:', error);
      }
    };

    // Use IntersectionObserver to check if the component is in the viewport
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // If the component is in the viewport, render the PDF
          handlePdf();

          // Disconnect observer after it has been triggered
          observer.disconnect();
        }
      });
    });

    // Observe the target component
    observer.observe(component);
  });
};
